// src/components/ConfirmationPopup.js
import React from "react";
import { getSearchParams } from "../utils/helpers";
import { useSelector } from "react-redux";
import { selectTerms } from "../features/terms/termsSlice";

const ConfirmationPopup = ({ onClose, onContinue }) => {
  const params = getSearchParams();
  const walletAddress = params.wa;
  const terms = useSelector(selectTerms);

  const handleContinue = () => {
    onContinue(walletAddress);
  };

  return (
    <div className="confirmation-popup">
      <div className="confirmation-popup-content">
        <h1>
          {/* Dear Customer: */}
          {terms.confirmation_popup_title}:
        </h1>
        <p>
          {/* Please note that you are buying USDT (tron) with Paybis, and it will
          be swapped automatically to USDP (Playblock) game tokens with
          coinexchange, for you to play. The swap can take a few minutes, and
          you will receive a confirmation mail by Coinsexchange. */}
          {terms.confirmation_popup_message}
        </p>
        <button onClick={handleContinue}>
          {/* OK, continue */}
          {terms.confirmation_popup_continue_button}
        </button>
        <button onClick={onClose}>
          {/* Close */}
          {terms.confirmation_popup_close_button}
        </button>
      </div>
    </div>
  );
};

export default ConfirmationPopup;
